import { Component, Schema, type, defaultValue } from "minecs";
/** The one owner of shared career state: wallet, reputation, identity and the airports this career keeps. */
@Component()
export class CareerState extends Schema {
    @type("string")
    @defaultValue("local-family")
    careerId: string;
    @type("string")
    @defaultValue("[]")
    savedCaptains: string;
    @type("number")
    @defaultValue(0)
    saveGameTime: number;

    @type("number")
    @defaultValue(40)
    money: number;
    @type("number")
    @defaultValue(0)
    prestige: number;
    @type("number")
    @defaultValue(0)
    offlineAward: number;
    @type("boolean")
    @defaultValue(true)
    offlineClaimed: boolean;
    /** JSON TerminalRecord[] of earlier airports this career still owns; frozen while absent in Act I. */
    @type("string")
    @defaultValue("[]")
    retainedAirports: string;
    /** Board advance owed (ECON-005): covers wage shortfalls interest-free and repays from later profit. */
    @type("number")
    @defaultValue(0)
    advance: number;
    /** TX-030 Family Diary: JSON array of short lines from real events, newest last. */
    @type("string")
    @defaultValue("[]")
    diary: string;
}
